import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { UploadImageRequest } from "app/models/menu.model";
import { take } from "rxjs";
import { DishesService } from "app/services/dishes.service";
import { DomSanitizer } from "@angular/platform-browser";

@UntilDestroy()
@Component({
  selector: 'app-select-image-field',
  templateUrl: './select-image-field.component.html',
  styleUrls: ['./select-image-field.component.scss']
})
export class SelectImageFieldComponent implements OnInit {
  reader = new FileReader();
  imgDefaultSrc = 'assets/images/dishes/logo.png';
  selectedImgSrc;

  @Input() allowOverrides: boolean;
  @Input() image: string;
  @Input() organizationId: string;
  @Input() overrideUrl: string;
  @Input() originalUrl: string;
  @Input() inputImgDefaultSrc: string;
  @Output() imageChanged = new EventEmitter<string>();

  constructor(
    private dishesService: DishesService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
    this.imgDefaultSrc = this.inputImgDefaultSrc ?? this.imgDefaultSrc;
    this.selectedImgSrc = this.image ? this.image : this.imgDefaultSrc;

    this.reader.onload = (e: any) => {
      const base64String = e.target.result
        .replace('data:', '')
        .replace(/^.+,/, '');

      const uploadImageRequest: UploadImageRequest = {
        organizationId: this.organizationId,
        imageBase64: base64String,
        IsDeletedPicture: false,
      };

      if (this.overrideUrl) {
        uploadImageRequest.imageUrl = this.overrideUrl;
      }

      this.dishesService.uploadImage$(uploadImageRequest)
        .pipe(take(1))
        .subscribe(res => {
          const imageUrl = res.data;
          this.imageChanged.emit(imageUrl);
          this.selectedImgSrc = this.sanitizer.bypassSecurityTrustResourceUrl(e.target.result);
        });
    };
  }

  changeImg(event): void {
    if(!this.allowOverrides){
      return;
    }
    this.selectedImgSrc = URL.createObjectURL(event.target.files[0]);
    if (event.target.files && event.target.files[0]) {
      this.reader.readAsDataURL(event.target.files[0]);
    }
  }

  deleteDishImg(): void {
    if(!this.allowOverrides){
      return;
    }
    this.selectedImgSrc = this.imgDefaultSrc;
    this.imageChanged.emit('');
  }

  restoreImg() {
    if(!this.allowOverrides){
      return;
    }
    this.selectedImgSrc = this.originalUrl ? this.originalUrl : this.imgDefaultSrc;
    this.imageChanged.emit(this.originalUrl ? this.originalUrl : '');
  }

  isShowRestore() {
    return (this.originalUrl && this.originalUrl !== this.selectedImgSrc) || (!this.originalUrl && this.selectedImgSrc !== this.imgDefaultSrc);
  }
}
